import aliciaEricksonAvatar from './assets/testimonials/alicia-erickson.png';
import juddLienhardAvatar from './assets/testimonials/judd-lienhard.png';
import mackenzieWellsAvatar from './assets/testimonials/mackenzie-wells.png';
import melaniaAntuchasAvatar from './assets/testimonials/melania-antuchas.png';
import jessicaCahoyAvatar from './assets/testimonials/jessica-cahoy.png';
import quintonPulliamAvatar from './assets/testimonials/quinton-pulliam.png';
import mitchJustineAvatar from './assets/testimonials/mitch-justine.png';
import danielleMaugerAvatar from './assets/testimonials/danielle-mauger.png';
import juliaMerwinAvatar from './assets/testimonials/julia-merwin.png';

export type Testimonial = {
  id: string;
  quote: string;
  authorName: string;
  authorRole: string;
  avatarSrc: string;
};

export const testimonialsData: Array<Testimonial> = [
  {
    id: 't-melania-antuchas',
    quote:
      'I literally set up the app and started making money within 48 hours. It was so easy!',
    authorName: 'Melania Antuchas',
    authorRole: 'The Pulse Effect',
    avatarSrc: melaniaAntuchasAvatar,
  },
  {
    id: 't-alicia-erickson',
    quote:
      "I can't say enough good things about Playbook. I'm incredibly grateful and I freaking love everybody at Playbook. It honestly feels like family. Playbook is the best app, the best platform",
    authorName: 'Alicia Erickson',
    authorRole: 'The Midlife Maven',
    avatarSrc: aliciaEricksonAvatar,
  },
  {
    id: 't-judd-lienhard',
    quote:
      "Originally, our 'dream goal' was to make $5k or $10k a month as a side stream of income. It turned out to be great. They've given us guidance the whole way, and I can really tell they care about more than just my brand. It's been an incredible experience.",
    authorName: 'Judd Lienhard',
    authorRole: 'Performance Coach',
    avatarSrc: juddLienhardAvatar,
  },
  {
    id: 't-mackenzie-wells',
    quote:
      'My stuff was all over the place and I needed a streamlined process. I looked into a lot of other apps and was on Zoom call after Zoom call hearing promise after promise, but Playbook is the best app and the best team. When I was on calls with the team, I just knew: these are my people. I started posting consistently and it just took off from there.',
    authorName: 'Mackenzie Wells',
    authorRole: 'Fitness',
    avatarSrc: mackenzieWellsAvatar,
  },
  {
    id: 't-jessica-cahoy',
    quote:
      'I joined Playbook in 2021 and it has been literally amazing. I get offers to join other platforms once a month, but I will never leave because it is such a beautiful, user-friendly platform. Since joining, my business has actually quadrupled in just the last eight months.',
    authorName: 'Jessica Cahoy',
    authorRole: 'Fitness & Weightloss Coach',
    avatarSrc: jessicaCahoyAvatar,
  },
  {
    id: 't-quinton-pulliam',
    quote:
      'I spent 10 years in firefighting and healthcare, but I always felt like I was meant for more. I started my app on Playbook, and within about six months, it started producing significant income. I spent a year and a half grinding 90 hours a week between my healthcare job and my fitness business until I finally replaced my professional income by two or three times',
    authorName: 'Quinton Pulliam',
    authorRole: 'Lifetime Natural Pro Bodybuilder',
    avatarSrc: quintonPulliamAvatar,
  },
  {
    id: 't-mitch-justine',
    quote: 'We love you guys!!! 😭 So happy we took a chance on Playbook',
    authorName: 'Mitch & Justine',
    authorRole: 'Run + Strength Coaches',
    avatarSrc: mitchJustineAvatar,
  },
  {
    id: 't-danielle-mauger',
    quote:
      'At 51, I am seriously having so much fun with all of this — cannot thank you enough for all of the support, resources, and amazing coaching ❤️ Playbook is THE best! ✨',
    authorName: 'Danielle Mauger',
    authorRole: 'Womens 45+ Strength Coach',
    avatarSrc: danielleMaugerAvatar,
  },
  {
    id: 't-julia-merwin',
    quote:
      'For any creator who wants to reach a wider audience and connect with your community, I highly highly recommend Playbook.',
    authorName: 'Julia Merwin',
    authorRole: 'JM Fitness',
    avatarSrc: juliaMerwinAvatar,
  },
];
